function fallbackCopyTextToClipboard(text: string) {
  const textArea = document.createElement('textarea');
  textArea.value = text;

  // Avoid scrolling to bottom
  textArea.style.top = '0';
  textArea.style.left = '0';
  textArea.style.position = 'fixed';

  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();

  try {
    document.execCommand('copy');
  } catch (err) {
    return null;
  }
  document.body.removeChild(textArea);
}

export const copyTextToClipboard = async (text: string) => {
  if (typeof window !== 'undefined') {
    if (!navigator.clipboard) {
      fallbackCopyTextToClipboard(text);
      return true;
    }
    await navigator.clipboard.writeText(text);
    return true;
  }
};
